import safeFetch from '../../utils/safeFetch';

const loginWithUrl = (url, params) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams(params);
    const fullUrl = `${url}?${queryParams.toString()}`;
    safeFetch(fullUrl, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => reject(error));
  });
};

export default loginWithUrl;
